// extracted by mini-css-extract-plugin
module.exports = {"container":"Sidebar_container__2j4Fh","compose":"Sidebar_compose__2Hopv","showMore__on":"Sidebar_showMore__on__-xKXY","showMore__off":"Sidebar_showMore__off__memzR"};